<template>
    <div class="row productMenuCreateBlock">
        <div class="col-xl-12 p-lr-0-sm">
            <div class="row">
                <div class="col-12 p-lr-0-sm">
                    <div class="multisteps-form">
                        <div class="row">
                            <div class="col-12 col-lg-8 mx-auto mt-4 mb-sm-5 mb-3 p-lr-0-sm">
                                <div class="multisteps-form__progress">
                                    <button class="multisteps-form__progress-btn active-form-step" @click="stage = 1" :class="{'active-form-step': (stage >= 1)}" type="button" title="Product Info"><span>1. Product</span></button>
                                    <button class="multisteps-form__progress-btn af-line" @click="stage = 2" :class="{'active-form-step': (stage >= 2)}" type="button" title="Media"><span>2. Attributes</span></button>
                                    <button class="multisteps-form__progress-btn af-line" @click="stage = 3" :class="{'active-form-step': (stage >= 3)}" type="button" title="Location"><span>3. Location</span></button>
                                    <button class="multisteps-form__progress-btn af-line" @click="stage = 4" :class="{'active-form-step': (stage == 4)}" type="button" title="Pricing"><span>4. Images</span></button>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 col-lg-8 m-auto p-lr-0-sm">
                                <form class="multisteps-form__form">

                                    <div class="card multisteps-form__panel p-3 dis-flex flex-column" v-show="stage == 1">
                                        <div class="dis-flex flex-m flex-sb multisteps-form__content">
                                            <div class="dis-flex flex-m">
                                                <i class="uis uis-create-dashboard mr-2 text-rose"></i>
                                                <h5 class="text-sm-b">Product Information</h5>
                                            </div>
                                            <div class="btn small-form-btn fs-10 pointer mt-0 ml-4" title="Translations Languages">
                                                <select class="translate-lang-swich pointer text-uppercase" name="translation-lang" @change="productData.selected_lang = $event.target.value">
                                                    <option v-for="(thisName, thisNameKey) in productData.name" :key="thisNameKey" :value="thisNameKey" :selected="productData.selected_lang == thisNameKey">{{ thisNameKey }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="multisteps-form__content">
                                            <div class="row mt-3">
                                                <div class="col-12 col-sm-6 p-lr-0-sm mb-2">
                                                    <div class="dis-flex flex-m flex-sb">
                                                        <label>Name</label>
                                                    </div>
                                                    <template v-for="(thisName, thisNameKey) in productData.name" :key="thisNameKey">
                                                        <input v-if="productData.selected_lang == thisNameKey" class="multisteps-form__input form-control" type="text" placeholder="Product Name" v-model="productData.name[thisNameKey]">
                                                    </template>
                                                </div>
                                                <div class="col-12 col-sm-6 p-lr-0-sm mb-2 flex-column flex-r">
                                                    <div class="dis-flex">
                                                        <div class="dis-flex flex-m flex-m ml-65 pr-5 full-structure-block">
                                                            <div class="form-check form-switch m-0 dis-flex flex-column flex-c">
                                                                <label class="ml-0 mb-3">Product Type</label>
                                                                <input class="form-check-input m-auto pointer noselect" id="productType-select" type="checkbox" name="productType-select" @change="productUnityTypeChange($event)" :checked="productData.unitType == 1">
                                                                <label class="dis-flex flex-m m-0 product-type-select pos-relative bottom-pos-105 noselect pointer" for="productType-select">
                                                                    <i class="uis uis-lamp fs-15 pos-relative pointer pos-left--06rem" title="Piece Product">
                                                                        <span class="text-xs txt-normal pos-absolute abriviation-l-pos">pcs.</span>
                                                                    </i>
                                                                    <i class="uis uis-balance-scale fs-15 pos-relative pointer pos-left-29rem noselect" title="Weight Product">
                                                                        <span class="text-xs txt-normal pos-absolute abriviation-r-pos">wgt.</span>
                                                                    </i>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div class="col-3 p-0 ml-auto" v-if="productData.unitType == 1">
                                                            <div class="dis-flex flex-r">
                                                                <div class="dis-flex flex-column flex-m">
                                                                    <label class="ml-0">Units</label>
                                                                    <select class="multisteps-form__input form-control dis-flex flex-m width-150 pl-45" name="Weight Product Measure">
                                                                        <option disabled hidden selected>-----</option>
                                                                        <option value="milligram" title="Milligram">mg</option>
                                                                        <option value="gram" title="Gram">g</option>
                                                                        <option value="kilogram" title="Kilogram">kg</option>
                                                                        <option value="tonne" title="Tonne">t</option>
                                                                        <option value="ounce" title="Ounce">oz</option>
                                                                        <option value="pound" title="Pound">lb</option>
                                                                        <option value="milliliter" title="Milliliter">ml</option>
                                                                        <option value="liter" title="Liter">L</option>
                                                                        <option value="gallon" title="Gallon">gal</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-12 col-md-12 col-lg-6 p-lr-0-sm mb-4 pos-relative">
                                                    <div class="dis-flex flex-m flex-sb">
                                                        <label>Brand</label>
                                                    </div>
                                                    <div class="pos-relative mb-3">
                                                        <select class="multisteps-form__input form-control pointer">
                                                            <option selected disabled>Choose Brand</option>
                                                            <option value="Woman">Cheese Perls</option>
                                                            <option value="Man">Cotted Cheese</option>
                                                            <option value="Kids">Fresh Cheese</option>
                                                        </select>
                                                        <i class="uis uis-angle-down pos-absolute selector-angle-down fs-20 pointer-none text-rose"></i>
                                                    </div>
                                                    <div class="dis-flex flex-m flex-sb">
                                                        <label>Short Description</label>
                                                    </div>
                                                    <template v-for="(thisName, thisNameKey) in productData.shortDescription">
                                                        <textarea v-if="productData.selected_lang == thisNameKey" :key="thisNameKey" class="small-txt-area w-full" maxlength="150" name="Product-Description" cols="30" rows="5" v-model="productData.shortDescription[thisNameKey]"></textarea>
                                                    </template>
                                                    <span class="fs-9 text-rose txt-italic pos-absolute p-r-15 p-lr-0-sm" style="right:0;">Max Symbols 150</span>
                                                </div>
                                                <div class="col-sm-12 col-md-12 col-lg-6 p-lr-0-sm mb-4 pos-relative">
                                                    <div class="dis-flex flex-m flex-sb">
                                                        <label>Full Description</label>
                                                    </div>
                                                    <template v-for="(thisName, thisNameKey) in productData.fullDescription">
                                                        <textarea v-if="productData.selected_lang == thisNameKey" :key="thisNameKey" class="small-txt-area w-full" maxlength="150" name="Additional-Description" cols="30" rows="9" v-model="productData.fullDescription[thisNameKey]"></textarea>
                                                    </template>
                                                    <span class="fs-9 text-rose txt-italic pos-absolute p-r-15 p-lr-0-sm" style="right:0;">Max Symbols 700</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="button-row dis-flex mt-auto flex-r">
                                            <button class="btn button-step-btn mb-0" type="button" title="Next Step" @click="stage = 2">Next</button>
                                        </div>
                                    </div>

                                    <div class="card multisteps-form__panel p-3 dis-flex flex-column" v-show="stage == 2">
                                        <div class="dis-flex flex-m flex-sb">
                                            <div class="dis-flex flex-m">
                                                <i class="uis uis-create-dashboard mr-2 text-rose"></i>
                                                <h5 class="text-sm-b">Attributes</h5>
                                            </div>
                                            <!-- <div class="dis-flex flex-m ml-auto pointer">
                                                <h5 class="text-xs text-back product-header pr-65 z-ind-0 static-header w-full text-truncate brand-header pos-relative">Louis Vuitton
                                                    <span class="uim-svg cl-btn-ml-mob-position fs-16 pos-absolute z-ind-1" title="Decline Brand">
                                                        <svg viewBox="0 0 24 24" width="1em">
                                                            <path class="uim-primary-w" d="M13.41406,12l2.293-2.293A.99989.99989,0,0,0,14.293,8.293L12,10.58594,9.707,8.293A.99989.99989,0,0,0,8.293,9.707L10.58594,12,8.293,14.293A.99989.99989,0,1,0,9.707,15.707L12,13.41406l2.293,2.293A.99989.99989,0,0,0,15.707,14.293Z"></path>
                                                            <path class="uim-tertiary-g" d="M19,2H5A3.00328,3.00328,0,0,0,2,5V19a3.00328,3.00328,0,0,0,3,3H19a3.00328,3.00328,0,0,0,3-3V5A3.00328,3.00328,0,0,0,19,2ZM15.707,14.293A.99989.99989,0,1,1,14.293,15.707L12,13.41406,9.707,15.707A.99989.99989,0,0,1,8.293,14.293L10.58594,12,8.293,9.707A.99989.99989,0,0,1,9.707,8.293L12,10.58594l2.293-2.293A.99989.99989,0,0,1,15.707,9.707L13.41406,12Z"></path>
                                                        </svg>
                                                    </span>
                                                </h5>
                                            </div> -->
                                            <div class="buttons-whatch-attirute">
                                                <button class="btn small-form-btn bar-code fs-10 mt-0 ml-3" title="Add Attribute" type="button"><i class="uis uis-brightness-plus fs-11"></i></button>
                                            </div>
                                        </div>

                                        <div class="multisteps-form__content mb-3">
                                            <div class="row mt-3">
                                                <div class="col-sm-12 col-md-12 col-xl-12 col-xxl-6 p-lr-0-sm mb-4" v-if="mainAttr.mainAttrTypeID">
                                                    <label>{{ mainAttr.mainAttrName }}</label>
                                                    <input class="multisteps-form__input form-control" type="text" :placeholder="'Select '+mainAttr.mainAttrName" readonly :value="componentsProductsCreateProductMainAttrString()" onclick="openCheckBoxMenu(this)">
                                                    <div class="atribute-selector-checkboxes mt-2" style="display: none;">
                                                        <ul class="submenu-dropdown-list-menu">
                                                            <template v-for="thisMainAttr in mainAttr.mainAttrList" :key="thisMainAttr.id">
                                                                <div class="w-full">
                                                                    <input class="avble-color-select" type="checkbox" :id="'thisMainAttr-'+thisMainAttr.name+'-'+thisMainAttr.id" v-model="thisMainAttr.selected" :disabled="thisMainAttr.disabled">
                                                                    <label v-if="thisMainAttr.display_color" class="label-color-checkbox" :class="{'cl--white': (globalGetBrightnessByColor(thisMainAttr.display_color) >= 220), 'black-check': (globalGetBrightnessByColor(thisMainAttr.display_color) >= 170)}" :style="{'background': thisMainAttr.display_color}" :for="'thisMainAttr-'+thisMainAttr.name+'-'+thisMainAttr.id"><span class="text-capitalize fs-11 dis-inline-block m-l-20 mw-clamp text-truncate">{{ thisMainAttr.name }}</span></label>
                                                                </div>
                                                            </template>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-12 col-xl-12 col-xxl-6 p-lr-0-sm mb-4">
                                                    <label>Size</label>
                                                    <input class="multisteps-form__input form-control" type="text" placeholder="Select Size" readonly :value="componentsProductsCreateProductSizesString()" onclick="openCheckBoxMenu(this)">
                                                    <div class="atribute-selector-checkboxes mt-2" style="display: none;">
                                                        <ul class="submenu-dropdown-list-menu pl-3 grid-repeat5">
                                                            <template v-for="thisSize in sizeList" :key="thisSize.size_id">
                                                                <input class="size-checkbox" type="checkbox" :id="'size-'+thisSize.size+'-'+thisSize.size_id" v-model="thisSize.selected" :disabled="thisSize.disabled">
                                                                <label class="label-size-checkbox" :for="'size-'+thisSize.size+'-'+thisSize.size_id">{{ thisSize.size }}</label>
                                                            </template>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-12 col-md-12 col-xl-12 col-xxl-6 p-lr-0-sm mb-3" v-for="thisSizeAndMainData in sizeAndMainAttrList" :key="thisSizeAndMainData.size_id+'-'+thisSizeAndMainData.main_attr_id">
                                                    <label>Bar / SKU - Codes for Product</label>
                                                    <div class="row">
                                                        <div class="col-sm-4 p-lr-0-sm mb-2"><span class="form-control bg-gray-200 text-sm-b">{{ thisSizeAndMainData.name }}</span></div>
                                                        <div class="col-sm-4 p-lr-0-sm mb-2 pos-relative">
                                                            <button class="btn small-form-btn bar-code fs-10 pos-absolute p-right-15 p-top--12r" title="Generate Barcode" type="button" onclick="createProdMakeNewBarcode(this)"><i class="fa fa-barcode"></i></button>
                                                            <input class="form-control barcodeInput" type="text" placeholder="Enter Barcode" v-model="thisSizeAndMainData.barcode" :style="{'border-color': (thisSizeAndMainData.barcode_error ? '#ff0000' : ''), 'color': (thisSizeAndMainData.barcode_error ? '#ff0000' : '')}">
                                                        </div>
                                                        <div class="col-sm-4 p-lr-0-sm"><input type="text" class="form-control skuCodeInput" placeholder="Enter SKU Code" v-model="thisSizeAndMainData.sku_code" :style="{'border-color': (thisSizeAndMainData.sku_code_error ? '#ff0000' : ''), 'color': (thisSizeAndMainData.sku_code_error ? '#ff0000' : '')}"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="button-row dis-flex flex-sb mt-auto">
                                            <button class="btn button-step-btn prev mb-0" type="button" title="Previous Step" @click="stage = 1">Prev</button>
                                            <button class="btn button-step-btn mb-0" type="button" title="Next Step" @click="stage = 3">Next</button>
                                        </div>
                                    </div>

                                    <div class="card multisteps-form__panel p-3 dis-flex flex-column" v-show="stage == 3">
                                        <div class="dis-flex flex-m">
                                            <i class="uis uis-create-dashboard mr-2 text-rose"></i>
                                            <h5 class="text-sm-b">Product Location</h5>
                                        </div>
                                        <div class="multisteps-form__content mb-3">
                                            <div class="row mt-3">
                                                <div class="col-sm-6 p-lr-0-sm mb-4">
                                                    <label>Category</label>
                                                    <div class="pos-relative">
                                                        <select class="multisteps-form__input form-control pointer">
                                                            <option selected disabled>Choose Category</option>
                                                            <option value="Woman">Cotted Cheese</option>
                                                            <option value="Man">Cheese Perls</option>
                                                            <option value="Kids">Fresh Cheese</option>
                                                        </select>
                                                        <i class="uis uis-angle-down pos-absolute selector-angle-down fs-20 pointer-none text-rose"></i>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6 p-lr-0-sm mb-4">
                                                    <label>Subcategory</label>
                                                    <div class="pos-relative">
                                                        <select class="multisteps-form__input form-control pointer">
                                                            <option selected disabled>Choose Subcategory</option>
                                                            <option value="Woman">Test Subcategory 1</option>
                                                            <option value="Man">Test Subcategory 2</option>
                                                            <option value="Kids">Test Subcategory 3</option>
                                                        </select>
                                                        <i class="uis uis-angle-down pos-absolute selector-angle-down fs-20 pointer-none text-rose"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-4">
                                                <div class="col-sm-6 p-lr-0-sm mb-4">
                                                    <label>Section</label>
                                                    <div class="pos-relative">
                                                        <select class="multisteps-form__input form-control pointer">
                                                            <option selected disabled>Choose Section</option>
                                                            <option value="Woman">Test Section 1</option>
                                                            <option value="Man">Test Section 2</option>
                                                            <option value="Kids">Test Section 3</option>
                                                        </select>
                                                        <i class="uis uis-angle-down pos-absolute selector-angle-down fs-20 pointer-none text-rose"></i>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6 p-lr-0-sm mb-4">
                                                    <label>Subsection</label>
                                                    <div class="pos-relative">
                                                        <select class="multisteps-form__input form-control pointer">
                                                            <option selected disabled>Choose Subsection</option>
                                                            <option value="">Test Subsection 1</option>
                                                            <option value="">Test Subsection 2</option>
                                                            <option value="">Test Subsection 3</option>
                                                            <option value="">Test Subsection 4</option>
                                                        </select>
                                                        <i class="uis uis-angle-down pos-absolute selector-angle-down fs-20 pointer-none text-rose"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="button-row d-flex flex-sb mt-auto">
                                            <button class="btn button-step-btn prev mb-0" type="button" title="Prev" @click="stage = 2">Prev</button>
                                            <button class="btn button-step-btn mb-0" type="button" title="Next" @click="stage = 4">Next</button>
                                        </div>
                                    </div>

                                    <div class="card multisteps-form__panel p-3 dis-flex flex-column" v-show="stage == 4">
                                        <div class="dis-flex flex-m">
                                            <i class="uis uis-create-dashboard mr-2 text-rose"></i>
                                            <h5 class="text-sm-b">Product Images</h5>
                                        </div>

                                        <div class="multisteps-form__content mb-3">
                                            <div class="row mt-3">
                                                <template v-if="mainAttr.mainAttrTypeID">
                                                    <div class="col-sm-12 col-md-12 col-xl-12 col-xxl-6 p-lr-0-sm mb-3 pos-relative upload-photo-block" v-for="thisMainAttrData in componentsProductsCreateProductSelectedMainAttr()" :key="thisMainAttrData.id">
                                                        <label class="dis-inline-block">Upload images for Product</label>
                                                        <span class="fs-12 text-success ml-2 mb-2"> - Uploaded: {{ thisMainAttrData.images.length }} - images</span>
                                                        <div class="row">
                                                            <div class="col-sm-4 p-lr-0-sm mb-2">
                                                                <span class="form-control bg-gray-200 text-sm-b">{{ thisMainAttrData.name }}</span>
                                                                <div class="btn medium-form-btn mt-2">
                                                                    <label :for="'mainAttrPhotoUpload'+thisMainAttrData.id">Choose Images</label>
                                                                    <input type="file" multiple accept="image/png, image/jpeg" :id="'mainAttrPhotoUpload'+thisMainAttrData.id" @change="componentsProductsCreateProductUploadMainAttrPhotos($event, thisMainAttrData)" :disabled="thisMainAttrData.images.length >= 5">
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-8 p-lr-0-sm mb-2 pos-relative">
                                                                <button class="btn small-form-btn bar-code fs-10 pos-absolute p-right-15-zoom p-top--12r-zoom" onclick="createProdMakeImgBiggerOrSmaller(this)" title="Show bigger images" type="button"><i class="uis uis-search"></i></button>
                                                                <div class="form-control photo-upload-area">
                                                                    <template v-if="thisMainAttrData.images.length > 0">
                                                                        <div class="dis-flex flex-column flex-m pos-relative" v-for="(thisMainAttrImage, thisMainAttrImageIdx) in thisMainAttrData.images" :key="thisMainAttrImageIdx">
                                                                            <div class="pos-absolute pointer image-delete-close-btn" title="Delete Image" @click="thisMainAttrData.images.splice(thisMainAttrImageIdx, 1)">
                                                                                <i class="uis uis-times-circle fs-17 text-rose"></i>
                                                                            </div>
                                                                            <label class="any-uploaded-photo pointer" :for="'mainAttr-'+thisMainAttrData.id+'-photo'+thisMainAttrImageIdx">
                                                                                <img v-if="thisMainAttrImage.imageData" :src="'data:image/jpg;base64,'+thisMainAttrImage.imageData" alt="">
                                                                                <img v-else :src="thisMainAttrImage.imageUrl" alt="">
                                                                            </label>
                                                                            <input class="main-photo-input mt-2" type="radio" @change="componentsProductsCreateProductSelectMainPhoto(thisMainAttrData, thisMainAttrImageIdx)" :checked="thisMainAttrImage.main" :name="'mainAttr-'+thisMainAttrData.id+'-photo'" :id="'mainAttr-'+thisMainAttrData.id+'-photo'+thisMainAttrImageIdx">
                                                                        </div>
                                                                    </template>
                                                                    <div class="m-auto txt-light fs-15" v-else>Images not uploaded yet</div>
                                                                </div>
                                                                <span class="fs-9 text-rose txt-italic pos-absolute p-r-15 p-lr-0-sm" style="right: 0px;">Max images 5</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="col-sm-12 col-md-12 col-xl-12 col-xxl-6 p-lr-0-sm mb-3 pos-relative upload-photo-block">
                                                        <label class="dis-inline-block">Upload images for Product</label>
                                                        <span class="fs-12 text-success ml-2 mb-2"> - Uploaded: 5 - images</span>
                                                        <div class="row">
                                                            <div class="col-sm-4 p-lr-0-sm mb-2">
                                                                <div class="btn medium-form-btn mt-2">
                                                                    <label for="mainProdPhotoUpload">Choose Images</label>
                                                                    <input type="file" multiple accept="image/png, image/jpeg" id="mainProdPhotoUpload" @change="componentsProductsCreateProductUploadMainAttrPhotos($event, components.products.createProduct)" :disabled="images.length >= 5">
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-8 p-lr-0-sm mb-2 pos-relative">
                                                                <button class="btn small-form-btn bar-code fs-10 pos-absolute p-right-15-zoom p-top--12r-zoom" onclick="createProdMakeImgBiggerOrSmaller(this)" title="Show bigger images" type="button"><i class="uis uis-search"></i></button>
                                                                <div class="form-control photo-upload-area">
                                                                    <template v-if="images.length > 0">
                                                                        <div class="dis-flex flex-column flex-m pos-relative" v-for="(thisMainImage, thisMainImageIdx) in images" :key="thisMainImageIdx">
                                                                                <div class="pos-absolute pointer image-delete-close-btn" title="Delete Image" @click="images.splice(thisMainImageIdx, 1)">
                                                                                    <i class="uis uis-times-circle fs-17 text-rose"></i>
                                                                                </div>
                                                                                <label class="any-uploaded-photo pointer" :for="'mainProdPhoto-'+thisMainImageIdx">
                                                                                    <img v-if="thisMainImage.imageData" :src="'data:image/jpg;base64,'+thisMainImage.imageData" alt="">
                                                                                    <img v-else :src="thisMainImage.imageUrl" alt="">
                                                                                </label>
                                                                                <input class="main-photo-input mt-2" type="radio" @change="componentsProductsCreateProductSelectMainPhoto(components.products.createProduct, thisMainImageIdx)" :checked="thisMainImage.main" :name="'mainProdPhotoCB'" :id="'mainProdPhoto-'+thisMainImageIdx">
                                                                        </div>
                                                                    </template>
                                                                    <div class="m-auto txt-light fs-15" v-else>Images not uploaded yet</div>
                                                                </div>
                                                                <span class="fs-9 text-rose txt-italic pos-absolute p-r-15 p-lr-0-sm" style="right: 0px;">Max images 5</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>

                                        <div class="button-row d-flex flex-sb mt-auto">
                                            <button class="btn button-step-btn prev mb-0" type="button" title="Prev" @click="stage = 3">Prev</button>
                                            <button class="btn button-step-btn create mb-0" type="button" title="Send">Create</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
let thisComponentData = {
    data() {
        return {
            stage: 1,
            images: [],
            sizeList: [],
            sizeAndMainAttrList: {},
            productData: {
                selected_lang: 'en',
                name: {},
                unitType: 0,
                weightUnitSelectedType: null,
                shortDescription: {},
                fullDescription: {},
            },
            mainAttr: {
                mainAttrTypeID: 1,
                mainAttrName: 'Color',
                mainAttrList: [
                    {
                        name: 'Green',
                        id: 1,
                        display_color: "#57837b",
                        display_photo: false,
                        selected: false,
                        disabled: false,
                        images: [],
                    },
                    {
                        name: 'Yellow',
                        id: 2,
                        display_color: "#f2d904",
                        display_photo: false,
                        selected: false,
                        disabled: false,
                        images: [],
                    },
                    {
                        name: 'Black',
                        id: 3,
                        display_color: "#000000",
                        display_photo: false,
                        selected: false,
                        disabled: false,
                        images: [],
                    },
                    {
                        name: 'White',
                        id: 4,
                        display_color: "#ffffff",
                        display_photo: false,
                        selected: false,
                        disabled: false,
                        images: [],
                    },
                    {
                        name: 'Pink',
                        id: 5,
                        display_color: "#ff00ff",
                        display_photo: false,
                        selected: false,
                        disabled: false,
                        images: [],
                    },
                    {
                        name: 'Light Blue',
                        id: 6,
                        display_color: "#00ffff",
                        display_photo: false,
                        selected: false,
                        disabled: false,
                        images: [],
                    },
                    {
                        name: 'Red',
                        id: 7,
                        display_color: "#ff0000",
                        display_photo: false,
                        selected: false,
                        disabled: false,
                        images: [],
                    },
                    {
                        name: 'Blue',
                        id: 8,
                        display_color: "#0000ff",
                        display_photo: false,
                        selected: false,
                        disabled: false,
                        images: [],
                    },
                    {
                        name: 'Orange',
                        id: 9,
                        display_color: "#ffa500",
                        display_photo: false,
                        selected: false,
                        disabled: false,
                        images: [],
                    },
                    {
                        name: 'Purple',
                        id: 10,
                        display_color: "#800080",
                        display_photo: false,
                        selected: false,
                        disabled: false,
                        images: [],
                    },
                    {
                        name: 'Brown',
                        id: 11,
                        display_color: "#a52a2a",
                        display_photo: false,
                        selected: false,
                        disabled: false,
                        images: [],
                    }
                    // {
                    //     name: 'Grey',
                    //     id: 12,
                    //     display_color: "#808080",
                    //     display_photo: false,
                    //     selected: false,
                    //     disabled: false,
                    //     images: [],
                    // },
                    // {
                    //     name: 'Dark Blue',
                    //     id: 13,
                    //     display_color: "#000080",
                    //     display_photo: false,
                    //     selected: false,
                    //     disabled: false,
                    //     images: [],
                    // },
                    // {
                    //     name: 'Light Green Light Yellow',
                    //     id: 14,
                    //     display_color: "#90ee90",
                    //     display_photo: false,
                    //     selected: false,
                    //     disabled: false,
                    //     images: [],
                    // },
                    // {
                    //     name: 'Light Yellow',
                    //     id: 15,
                    //     display_color: "#ffffe0",
                    //     display_photo: false,
                    //     selected: false,
                    //     disabled: false,
                    //     images: [],
                    // },
                    // {
                    //     name: 'Light Pink',
                    //     id: 16,
                    //     display_color: "#ffb6c1",
                    //     display_photo: false,
                    //     selected: false,
                    //     disabled: false,
                    //     images: [],
                    // },
                    // {
                    //     name: 'Light Grey',
                    //     id: 17,
                    //     display_color: "#d3d3d3",
                    //     display_photo: false,
                    //     selected: false,
                    //     disabled: false,
                    //     images: [],
                    // },
                    // {
                    //     name: 'Light Red',
                    //     id: 18,
                    //     display_color: "#ffc0cb",
                    //     display_photo: false,
                    //     selected: false,
                    //     disabled: false,
                    //     images: [],
                    // },
                    // {
                    //     name: 'Light Brown',
                    //     id: 19,
                    //     display_color: "#f5deb3",
                    //     display_photo: false,
                    //     selected: false,
                    //     disabled: false,
                    //     images: [],
                    // },
                    // {
                    //     name: 'Light Orange',
                    //     id: 20,
                    //     display_color: "#ffefd5",
                    //     display_photo: false,
                    //     selected: false,
                    //     disabled: false,
                    //     images: [],
                    // },
                    // {
                    //     name: 'Light Purple',
                    //     id: 21,
                    //     display_color: "#d8bfd8",
                    //     display_photo: false,
                    //     selected: false,
                    //     disabled: false,
                    //     images: [],
                    // }
                ]
            },
            sizeList: [
                {
                    size: '35gr.',
                    size_id: 1,
                    selected: false,
                    disabled: false,
                },
                {
                    size: '150gr.',
                    size_id: 2,
                    selected: false,
                    disabled: false,
                },
                {
                    size: '300gr.',
                    size_id: 3,
                    selected: false,
                    disabled: false,
                },
                {
                    size: '350gr.',
                    size_id: 4,
                    selected: false,
                    disabled: false,
                },
                {
                    size: '400gr.',
                    size_id: 5,
                    selected: false,
                    disabled: false,
                },
                // {
                //     size: 'XXL',
                //     size_id: 6,
                //     selected: false,
                //     disabled: false,
                // },
                // {
                //     size: '3XL',
                //     size_id: 7,
                //     selected: false,
                //     disabled: false,
                // },
                // {
                //     size: '35',
                //     size_id: 8,
                //     selected: false,
                //     disabled: false,
                // },
                // {
                //     size: '36',
                //     size_id: 9,
                //     selected: false,
                //     disabled: false,
                // },
                // {
                //     size: '37',
                //     size_id: 10,
                //     selected: false,
                //     disabled: false,
                // },
                // {
                //     size: '38',
                //     size_id: 11,
                //     selected: false,
                //     disabled: false,
                // },
                // {
                //     size: '39',
                //     size_id: 12,
                //     selected: false,
                //     disabled: false,
                // },
                // {
                //     size: '40',
                //     size_id: 13,
                //     selected: false,
                //     disabled: false,
                // },
                // {
                //     size: '41',
                //     size_id: 14,
                //     selected: false,
                //     disabled: false,
                // },
                // {
                //     size: '42',
                //     size_id: 15,
                //     selected: false,
                //     disabled: false,
                // },
                // {
                //     size: '43',
                //     size_id: 16,
                //     selected: false,
                //     disabled: false,
                // }
            ]
        }
    },
    methods: {
        componentsProductsCreateProductSizesString: function () {
            let sizeList = this.sizeList
            let sizeListString = ''
            let selectedSizeList = sizeList.filter(function(thisSize) {
                if (thisSize.selected) return true
            })
            if (selectedSizeList.length > 0) {
                sizeListString = selectedSizeList.map(function(thisSize) {
                    return thisSize.size
                }).join(', ')
            }
            return sizeListString
        },
        componentsProductsCreateProductMainAttrString: function () {
            let mainAttrList = this.mainAttr.mainAttrList
            let mainAttrListString = ''
            let selectedMainAttrList = mainAttrList.filter(function(thisMainAttr) {
                if (thisMainAttr.selected) return true
            })
            if (selectedMainAttrList.length > 0) {
                mainAttrListString = selectedMainAttrList.map(function(thisMainAttr) {
                    return thisMainAttr.name
                }).join(', ')
            }
            return mainAttrListString
        },
        componentsProductsCreateProductSelectedMainAttr: function () {
            let mainAttrList = this.mainAttr.mainAttrList
            let selectedMainAttrList = mainAttrList.filter(function(thisMainAttr) {
                if (thisMainAttr.selected) return true
            })
            return selectedMainAttrList
        },
        componentsProductsCreateProductSizeAndMainAttrList: function () {
            let sizeList = this.sizeList
            let mainAttrList = this.mainAttr.mainAttrList
            let thisVue = this
            
            let selectedSizeList = sizeList.filter(function(thisSize) {
                if (thisSize.selected) return true
            })
            let selectedMainAttrList = mainAttrList.filter(function(thisMainAttr) {
                if (thisMainAttr.selected) return true
            })

            let sizeAndMainAttrList = {}
            if (selectedMainAttrList.length > 0 && thisVue.mainAttr.mainAttrTypeID) {
                if (selectedSizeList.length > 0) {
                    selectedMainAttrList.forEach(function(thisMainAttr) {
                        selectedSizeList.forEach(function(thisSize) {
                            sizeAndMainAttrList[`${thisMainAttr.id} - ${thisSize.size_id}`] = {
                                name: `${thisMainAttr.name} - ${thisSize.size}`,
                                size_id: thisSize.size_id,
                                main_attr_type_id: thisVue.mainAttr.mainAttrTypeID,
                                main_attr_id: thisMainAttr.id,
                                barcode: '',
                                barcode_error: false,
                                sku_code: '',
                                sku_code_error: false,
                            }
                        })
                    })
                }
            } else if (selectedSizeList.length > 0 && !thisVue.mainAttr.mainAttrTypeID) {
                selectedSizeList.forEach(function(thisSize) {
                    sizeAndMainAttrList[`${thisSize.size_id}`] = {
                        name: `${thisSize.size}`,
                        size_id: thisSize.size_id,
                        main_attr_type_id: false,
                        main_attr_id: false,
                        barcode: '',
                        barcode_error: false,
                        sku_code: '',
                        sku_code_error: false,
                    }
                })
            }

            let barcodeList = {}
            let skucodeList = {}
            for (const key in sizeAndMainAttrList) {
                let thisSizeAndMainAttr = sizeAndMainAttrList[key]
                if (this.sizeAndMainAttrList.hasOwnProperty(key)) {
                    thisSizeAndMainAttr.barcode = this.sizeAndMainAttrList[key].barcode
                    if (thisSizeAndMainAttr.barcode && thisSizeAndMainAttr.barcode.length > 0) {
                        if (barcodeList.hasOwnProperty(thisSizeAndMainAttr.barcode)) {
                            thisSizeAndMainAttr.barcode_error = true
                        } else {
                            if (thisSizeAndMainAttr.barcode_error) {
                                thisSizeAndMainAttr.barcode_error = false
                            }
                            barcodeList[thisSizeAndMainAttr.barcode] = true
                        }
                    }

                    thisSizeAndMainAttr.sku_code = this.sizeAndMainAttrList[key].sku_code
                    if (thisSizeAndMainAttr.sku_code && thisSizeAndMainAttr.sku_code.length > 0) {
                        if (skucodeList.hasOwnProperty(thisSizeAndMainAttr.sku_code)) {
                            thisSizeAndMainAttr.sku_code_error = true
                        } else {
                            if (thisSizeAndMainAttr.sku_code_error) {
                                thisSizeAndMainAttr.sku_code_error = false
                            }
                            skucodeList[thisSizeAndMainAttr.sku_code] = true
                        }
                    }
                }
            }

            this.sizeAndMainAttrList = sizeAndMainAttrList
        },
        componentsProductsCreateProductUploadMainAttrPhotos: function(thisEvent, mainAttrObj) {
            if (mainAttrObj.images.length == 5) return

            // console.log(thisEvent.target.files)
            let imgFileCount = 0
            let maxImgFileCount = (5 - mainAttrObj.images.length)
            for (const key in thisEvent.target.files) {
                const thisNewImage = thisEvent.target.files[key]
                if (imgFileCount >= maxImgFileCount) break;
                else if (typeof thisNewImage != 'object') continue;
                else if (key == 'length') continue;
                else if (thisNewImage.type.indexOf('image') != 0) continue;

                const reader = new FileReader();
                reader.onload = function() {
                    const base64 = this.result.replace(/.*base64,/, '');
                    mainAttrObj.images.push({
                        imageData: base64,
                        imageUrl: null,
                        main: mainAttrObj.images.length == 0 ? true : false,
                    })
                };
                reader.readAsDataURL(thisNewImage);
                imgFileCount++
            }
            thisEvent.target.value = ''
        },
        componentsProductsCreateProductSelectMainPhoto: function(mainAttrObj, thisSelectedPhotoIdx) {
            mainAttrObj.images.forEach(function(thisPhoto, thisPhotoIdx) {
                if (thisPhotoIdx == thisSelectedPhotoIdx) {
                    thisPhoto.main = true
                } else if (thisPhoto.main) {
                    thisPhoto.main = false
                }
            })
        },
        globalGetBrightnessByColor(color) {
            color = "" + color
            let isHEX = color.indexOf("#") == 0, isRGB = color.indexOf("rgb") == 0;
            let r, g, b;
            if (isHEX) {
                const hasFullSpec = color.length == 7;
                let m = color.substr(1).match(hasFullSpec ? /(\S{2})/g : /(\S{1})/g);
                if (m) r = parseInt(m[0] + (hasFullSpec ? '' : m[0]), 16), g = parseInt(m[1] + (hasFullSpec ? '' : m[1]), 16), b = parseInt(m[2] + (hasFullSpec ? '' : m[2]), 16);
            }
            if (isRGB) {
                let m = color.match(/(\d+){1,3}/g);
                if (m) r = m[0], g = m[1], b = m[2];
            }
            if (typeof r != "undefined") return ((r*299)+(g*587)+(b*114))/1000;
        },
        productUnityTypeChange(event) {
            this.productData.unitType = event.target.checked ? 1 : 0
            this.productData.weightUnitSelectedType = null
        }
    },
    watch: {
        'sizeList': {
            handler: function(newValue, oldValue) {
                this.componentsProductsCreateProductSizeAndMainAttrList()
                setTimeout(() => {
                    this.componentsProductsCreateProductBarcodeAndSkuCodeChecker()
                }, 500);
            }, 
            deep: true
        },
        'mainAttr.mainAttrList': {
            handler: function(newValue, oldValue) {
                this.componentsProductsCreateProductSizeAndMainAttrList()
                setTimeout(() => {
                    this.componentsProductsCreateProductBarcodeAndSkuCodeChecker()
                }, 500);
            },
            deep: true
        },
        '$store.state.languages': {
            handler: function(newLangObj, oldLangObj) {
                for (const key in newLangObj) {
                    if (!this.productData.name.hasOwnProperty(key)) {
                        this.productData.name[key] = ''
                    }
                    if (!this.productData.shortDescription.hasOwnProperty(key)) {
                        this.productData.shortDescription[key] = ''
                    }
                    if (!this.productData.fullDescription.hasOwnProperty(key)) {
                        this.productData.fullDescription[key] = ''
                    }
                }
            },
            deep: true
        }
    },
    mounted: function() {
        for (const key in this.$store.state.languages) {
            if (!this.productData.name.hasOwnProperty(key)) {
                this.productData.name[key] = ''
            }
            if (!this.productData.shortDescription.hasOwnProperty(key)) {
                this.productData.shortDescription[key] = ''
            }
            if (!this.productData.fullDescription.hasOwnProperty(key)) {
                this.productData.fullDescription[key] = ''
            }
        }
    }
}

function barcodeAndSkuCodeChecker(thisVue) {
    if (!thisVue) thisVue = this
    $('.productMenuBlock .productMenuCreateBlock .barcodeInput:not(.handled)').each(function() {
        $(this).addClass('handled')
        $(this).on('change', barAndSkuChange)
    })

    $('.productMenuBlock .productMenuCreateBlock .skuCodeInput:not(.handled)').each(function() {
        $(this).addClass('handled')
        $(this).on('change', barAndSkuChange)
    })

    function barAndSkuChange() {
        checkBarcodeInVue(thisVue)
    }

    function checkBarcodeInVue(thisVue) {
        let barcodeList = {}
        let skucodeList = {}
        for (const key in thisVue.sizeAndMainAttrList) {
            let thisSizeAndMainAttr = thisVue.sizeAndMainAttrList[key]
            if (thisSizeAndMainAttr.barcode && thisSizeAndMainAttr.barcode.length > 0) {
                if (barcodeList.hasOwnProperty(thisSizeAndMainAttr.barcode)) {
                    thisSizeAndMainAttr.barcode_error = true
                } else {
                    if (thisSizeAndMainAttr.barcode_error) {
                        thisSizeAndMainAttr.barcode_error = false
                    }
                    barcodeList[thisSizeAndMainAttr.barcode] = true
                }
            }

            if (thisSizeAndMainAttr.sku_code && thisSizeAndMainAttr.sku_code.length > 0) {
                if (skucodeList.hasOwnProperty(thisSizeAndMainAttr.sku_code)) {
                    thisSizeAndMainAttr.sku_code_error = true
                } else {
                    if (thisSizeAndMainAttr.sku_code_error) {
                        thisSizeAndMainAttr.sku_code_error = false
                    }
                    skucodeList[thisSizeAndMainAttr.sku_code] = true
                }
            }
        }
    }
}
thisComponentData.methods.componentsProductsCreateProductBarcodeAndSkuCodeChecker = barcodeAndSkuCodeChecker

export default thisComponentData
</script>

<style>

</style>